import { ChevronLeft, ChevronRight } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'src/components/ui/button';
import { Progress } from 'src/components/ui/progress';
import { Skeleton } from 'src/components/ui/skeleton';

export function ForecastPaginatedActionsSkeleton() {
  const { t } = useTranslation('forecast');

  return (
    <div className='flex w-full flex-col gap-4 lg:flex-row lg:items-center lg:justify-between'>
      <div className='flex w-full flex-col gap-4 lg:flex-row lg:items-center lg:gap-x-4'>
        <Skeleton className='h-10 w-full lg:w-[17rem]' />
        <div>
          <Button
            className='rounded-r-none border-r-[0.5px] focus:ring-0 focus:ring-offset-0'
            variant='outline'
            size='sm'
            disabled
          >
            <ChevronLeft className='mr-1 h-4 w-4' />
          </Button>
          <Button
            className='rounded-l-none border-l-[0.5px] focus:ring-0 focus:ring-offset-0'
            variant='outline'
            size='sm'
            disabled
          >
            <ChevronRight className='ml-1 h-4 w-4' />
          </Button>
        </div>
        <div className='mt-1 flex flex-col gap-y-1'>
          <Skeleton className='h-3 w-14 self-end' />
          <Progress value={0} className='w-48' />
        </div>
      </div>
      <div className='flex flex-wrap items-center gap-3 lg:flex-nowrap lg:gap-x-4'>
        <Button variant='secondary' disabled>
          {t('Reset')}
        </Button>
        <Button variant='outline' disabled>
          {t('Skip')}
        </Button>
        <Button disabled>{t('Validate')}</Button>
      </div>
    </div>
  );
}
